import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=9a88393a&scoped=true"
import script from "./StatusTag.vue?vue&type=script&lang=js"
export * from "./StatusTag.vue?vue&type=script&lang=js"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=9a88393a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a88393a",
  null
  
)

export default component.exports